import React, { useState, useEffect } from 'react'

import { NotificationManager } from '../../../common/components/Notifications'
import { FileUploadButton } from '../../../common/components/file-upload-button'
import { usePageEditorContext } from '../../contexts/page-editor.context'
import { imageBlockService } from './image-block.service'

import { useStyles } from './image-block-edit-sidebar.style'

export const ImageBlockEditSidebar = function ({ block }) {
  const classes = useStyles()

  const pageEditorContext = usePageEditorContext() || {}

  const [file, setFile] = useState()

  useEffect(() => {
    if (!file) {
      return
    }

    // Build image preview
    const reader = new FileReader()
    reader.onloadend = () => {
      pageEditorContext.setCurrentEdit({ block, onSave, imagePreviewUrl: reader.result })
    }
    reader.readAsDataURL(file)
  }, [ file ])

  function onSave (data) {
    if (file) {
      return imageBlockService.uploadImage(pageEditorContext.pageId, block.key, file)
    }
    return data
  }

  function handleImageChange (event) {
    if (!event.target.files || event.target.files.length < 1) {
      return
    }

    const newFile = event.target.files[0]

    if (!imageBlockService.isValidImage(newFile)) {
      NotificationManager.create({ type: 'error', timeOut: 10000, message: 'The file you selected is not a valid image format.' })
      event.target.value = null
      return
    }

    pageEditorContext.registerUnsavedChanges()
    setFile(newFile)
  }

  return <div className={classes.uploadButtonContainer}>
    <FileUploadButton onChange={handleImageChange} label="Choose an image..." accept="image/*" />
  </div>
}
